import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
} from '@mui/material';
import {
  ArrowForward as ArrowForwardIcon,
  EventNote as MeetingIcon,
} from '@mui/icons-material';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [meetingId, setMeetingId] = useState('');
  const [error, setError] = useState('');


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!meetingId.trim()) {
      setError('Please enter a meeting ID');
      return;
    }

    // Navigate to the meeting
    navigate(`/meeting/${meetingId.trim()}`);
  };


  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Box sx={{ mb: 4 }}>
            <MeetingIcon 
              sx={{ 
                fontSize: 48, 
                color: 'primary.main',
                mb: 2 
              }} 
            />
            <Typography variant="h4" gutterBottom color="primary">
              Welcome to Cascade
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Enter a meeting ID to view tasks and takeaways
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleSubmit} sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Enter meeting ID"
              value={meetingId}
              onChange={(e) => setMeetingId(e.target.value)}
              sx={{ mb: 2 }}
              autoFocus
            />
            
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{ 
                px: 4,
                py: 1.5,
                mb: 2,
              }}
              fullWidth
            >
              Go to Meeting
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Home;
